exports.chartPoints = function (interations, fields, qtdItems, xPointRef) {
  if (!qtdItems || !interations || interations.length === 0) return []

  function interationPoints (interation, xPointRef) {
    if (!interation.forms) return

    let forms = interation.forms
    let days = forms['gestationalAge.info.calculada']
    if (!days) return
    let week = days / 7
    let points = []

    for (let f = 0; f < fields.length; f++) {
      for (let i = 1; i <= qtdItems; i++) {
        let key = fields[f].replace(/\$/, `_${i}`)
        let value = forms[key]
        if (value && typeof value === 'object') value = value.result
        if (!value && value !== 0) continue
        let point
        if (xPointRef) {
          const xValue = forms[xPointRef.replace(/\$/, `_${i}`)]
          if (!xValue) continue
          point = { id: i, week: xValue, value: parseFloat(value) }
        } else {
          point = { id: i, week: week, value: parseFloat(value) }
        }
        points.push(point)
      }
    }

    return points
  }

  let points = []
  for (let i = 0; i < interations.length; i++) {
    let iPoints = interationPoints(interations[i], xPointRef)
    if (iPoints) points = points.concat(iPoints)
  }
  return points
}



// WEBPACK FOOTER //
// ./src/api/formCharts.js